
const BANNER_STORAGE_KEY = "wetheme-banner";

/**
 * ローカルストレージが使えるかどうか
 */
function hasLocalStorage() {
  try {
    return typeof Storage !== "undefined" && window.localStorage;
  } catch (e) {
    return false;
  }
}

/**
 * ポップアップの表示制御用 有効期限が切れている、または未設定かどうか
 */
function isBannerExpiredOrNotSet() {
  if (!hasLocalStorage()) return true;

  const saved = window.localStorage.getItem(BANNER_STORAGE_KEY);
  if (saved) {
    try {
      const expiry = JSON.parse(saved).expiry;
      return Date.parse(expiry) <= Date.now();
    } catch (e) {
      console.warn("Unable to read banner expiry date", e);
      return true;
    }
  }
  return true;
}

/**
 * ローカルストレージに有効期限（n日後）を保存
 */
function setBannerExpiry(days) {
  const expiryDate = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  try {
    if (hasLocalStorage()) {
      localStorage.setItem(BANNER_STORAGE_KEY, JSON.stringify({ expiry: expiryDate.toISOString() }));
    }
  } catch (e) {
    console.warn("Unable to set banner expiry:", e);
  }
}

/**
 * テストモードかどうかをdata属性から判定
 * @param {HTMLElement} element - 例えば #banner など
 */
function isTestModeEnabled(element) {
  return element?.dataset?.bannerTestMode === "true";
}

function showFn(element) {
  element.style.display = 'block';
}

/**
 * ポップアップ制御ロジックの起動関数
 * @param {Object} options
 *    - element: HTML要素（data-banner-test-mode属性参照）
 *    - skipDays: 非表示期間（日数）
 *    - delayMs: 表示までの遅延（ミリ秒）
 */
function controlBanner(element) {
  const testMode = isTestModeEnabled(element);

  if (testMode) {
    showFn(element);  // テストモードでは毎回表示
  } else if (isBannerExpiredOrNotSet()) {
    showFn(element);
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const bannerElement = document.querySelector('#global-follow-banner');

  if (!bannerElement) return;

  controlBanner(bannerElement);
  document.querySelector(".global-follow-banner__close")?.addEventListener('click', () => {
    bannerElement.style.display = 'none';
    setBannerExpiry(bannerElement.dataset.bannerTime);
  });
});
